export default {
  defaultSortField: 'name',
  defaultSortOrder: 'asc',
  rearrangeCols: false,
  fields: [{
    name: 'select-catalog',
    prop: 'selected',
    width: '32px',
    title: '',
    id: 'selectCatalog',
  },{
    name: 'field-generic-input',
    prop: 'name',
    width: '430px',
    title: 'Item Name',
    id: 'name',
  }, {
    name: 'field-cat-id',
    prop: 'catId',
    width: '152px',
    title: 'Catalog ID',
    id: 'catId',
  }, {
    name: 'field-generic-input',
    prop: 'available',
    width: '112px',
    title: 'In Stock',
    id: 'available',
  }, {
    name: 'qty-needed',
    prop: 'qtyNeeded',
    width: '136px',
    title: 'Qty Needed',
    id: 'qtyNeeded',
  }],
};
